"use client";
import React from "react";

/**
 * Skeleton that matches the LeadFormFeilds component layout.
 * Shows shimmer placeholders for: social sign-in, name fields, email, password,
 * enquiry textarea, year of entry chips, consent checkboxes, and submit button.
 */
const LeadFormFieldsSkeleton = () => {
  return (
    <div className="border-y md:border border-grey-200 md:rounded-[8px] overflow-hidden">
      <div className="bg-white p-[32px_16px] md:p-[32px] flex flex-col gap-[24px]">
        {/* Header: title + description */}
        <div className="flex flex-col gap-[8px]">
          <div className="skeleton skeleton-text-animated !h-[24px] !w-[220px] !m-0 !rounded-[4px]"></div>
          <div className="skeleton skeleton-text-animated !h-[16px] !w-[300px] !m-0 !rounded-[3px]"></div>
        </div>

        {/* Social sign-in section */}
        <div className="flex flex-col gap-[16px]">
          <div className="skeleton skeleton-text-animated !h-[18px] !w-[260px] !m-0 !rounded-[3px]"></div>
          <div className="skeleton skeleton-text-animated !h-[14px] !w-full max-w-[400px] !m-0 !rounded-[3px]"></div>
          <div className="flex flex-col gap-[8px]">
            <div className="skeleton skeleton-text-animated !h-[40px] w-full !rounded-[10px] !m-0"></div>
            <div className="skeleton skeleton-text-animated !h-[40px] w-full !rounded-[10px] !m-0"></div>
            <div className="skeleton skeleton-text-animated !h-[40px] w-full !rounded-[10px] !m-0"></div>
          </div>
          <div className="flex justify-center">
            <div className="skeleton skeleton-text-animated !h-[12px] !w-[180px] !m-0 !rounded-[3px]"></div>
          </div>
        </div>

        <hr className="bg-grey-200" />

        {/* Form fields */}
        <div className="flex flex-col gap-[24px]">
          {/* Enquiry textarea */}
          <div className="flex flex-col gap-[4px]">
            <div className="skeleton skeleton-text-animated !h-[16px] !w-[100px] !m-0"></div>
            <div className="skeleton skeleton-text-animated !h-[83px] md:!h-[62px] w-full !rounded-[4px] !m-0"></div>
          </div>

          {/* First name + Last name row */}
          <div className="flex flex-col md:flex-row gap-[24px] md:gap-[8px]">
            <div className="flex-1 flex flex-col gap-[4px]">
              <div className="skeleton skeleton-text-animated !h-[16px] !w-[88px] !m-0"></div>
              <div className="skeleton skeleton-text-animated !h-[42px] w-full !rounded-[4px] !m-0"></div>
            </div>
            <div className="flex-1 flex flex-col gap-[4px]">
              <div className="skeleton skeleton-text-animated !h-[16px] !w-[86px] !m-0"></div>
              <div className="skeleton skeleton-text-animated !h-[42px] w-full !rounded-[4px] !m-0"></div>
            </div>
          </div>

          {/* Email */}
          <div className="flex flex-col gap-[4px]">
            <div className="skeleton skeleton-text-animated !h-[16px] !w-[110px] !m-0"></div>
            <div className="skeleton skeleton-text-animated !h-[42px] w-full !rounded-[4px] !m-0"></div>
          </div>

          {/* Password */}
          <div className="flex flex-col gap-[4px]">
            <div className="skeleton skeleton-text-animated !h-[16px] !w-[82px] !m-0"></div>
            <div className="skeleton skeleton-text-animated !h-[42px] w-full !rounded-[4px] !m-0"></div>
            <div className="flex justify-center divide-x divide-grey-200 pt-[2px]">
              <div className="skeleton skeleton-text-animated !h-[14px] !w-[30px] px-[8px] !m-0"></div>
              <div className="skeleton skeleton-text-animated !h-[14px] !w-[26px] px-[8px] !m-0"></div>
              <div className="skeleton skeleton-text-animated !h-[14px] !w-[24px] px-[8px] !m-0"></div>
              <div className="skeleton skeleton-text-animated !h-[14px] !w-[26px] px-[8px] !m-0"></div>
              <div className="skeleton skeleton-text-animated !h-[14px] !w-[82px] px-[8px] !m-0"></div>
            </div>
          </div>

          {/* Year of entry chips */}
          <div className="flex flex-col gap-[4px]">
            <div className="skeleton skeleton-text-animated !h-[16px] !w-[160px] !m-0"></div>
            <div className="flex flex-row gap-[6px] md:gap-[8px]">
              <div className="skeleton skeleton-text-animated !h-[34px] !w-[70px] !rounded-[18px] !m-0"></div>
              <div className="skeleton skeleton-text-animated !h-[34px] !w-[70px] !rounded-[18px] !m-0"></div>
              <div className="skeleton skeleton-text-animated !h-[34px] !w-[70px] !rounded-[18px] !m-0"></div>
              <div className="skeleton skeleton-text-animated !h-[34px] !w-[70px] !rounded-[18px] !m-0"></div>
            </div>
          </div>
        </div>

        <hr className="bg-grey-200" />

        {/* Legal text */}
        <div className="flex flex-col gap-[4px]">
          <div className="skeleton skeleton-text-animated !h-[12px] w-full !m-0 !rounded-[3px]"></div>
          <div className="skeleton skeleton-text-animated !h-[12px] !w-[85%] !m-0 !rounded-[3px]"></div>
        </div>

        {/* Submit button */}
        <div className="skeleton skeleton-text-animated !h-[44px] w-full !rounded-[9999px] !m-0"></div>
      </div>
    </div>
  );
};

export default LeadFormFieldsSkeleton;
